// /src/pages/private/members/academyTools/components/AcademyCourseSidebar.jsx



import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { courseHasMatchingDocuments } from '../utils/documentPreviewCache';



function groupCoursesByTrainingLevel(courses) {

  const groups = new Map();



  for (const course of courses) {

    const levelId = Number(course.trainingLevelId) || 0;

    const levelName = course.trainingLevelName || 'Other';

    const levelOrder = Number(course.trainingLevelOrder) || 0;



    if (!groups.has(levelId)) {

      groups.set(levelId, { levelId, levelName, levelOrder, courses: [] });

    }



    groups.get(levelId).courses.push(course);

  }



  return [...groups.values()]

    .sort((a, b) => {

      if (a.levelOrder !== b.levelOrder) return a.levelOrder - b.levelOrder;

      return a.levelId - b.levelId;

    })

    .map((group) => ({

      ...group,

      courses: [...group.courses].sort((a, b) =>

        String(a.displayName || '').localeCompare(String(b.displayName || ''))

      ),

    }));

}



export default function AcademyCourseSidebar({
  courses,
  selectedCourseId,
  onSelectCourse,
  searchTerm = '',
}) {

  const { t } = useTranslation();

  const courseGroups = useMemo(

    () => groupCoursesByTrainingLevel(courses),

    [courses]

  );



  return (

    <div className="member-academy-course-list" aria-label={t('Academy')}>

      <div className="member-academy-course-list__header">

        <h3 className="member-academy-course-list__title">Courses</h3>

        <span className="member-academy-course-list__count">{courses.length}</span>

      </div>



      <div className="member-academy-course-list__scroll">

        {!courses.length ? (

          <p className="member-academy-course-list__empty">No courses available for your rank.</p>

        ) : (

          courseGroups.map((group, groupIndex) => (

            <React.Fragment key={group.levelId}>

              {groupIndex > 0 ? (

                <hr className="member-academy-course-list__section-separator" aria-hidden="true" />

              ) : null}

              <p className="member-academy-course-list__group-title">{group.levelName}</p>

              {group.courses.map((course) => {
                const isSelected = course.id === selectedCourseId;
                const isSearchMatch = courseHasMatchingDocuments(course, searchTerm);
                const documentCount = course.documentCount ?? course.documents?.length ?? 0;
                const isPromotionLocked = Boolean(course.promotionGateLocked);

                return (
                  <div
                    key={course.id}
                    className={[
                      'member-academy-course-item',
                      isSelected ? 'member-academy-course-item--selected' : '',
                      isSearchMatch ? 'member-academy-course-item--search-match' : '',
                      isPromotionLocked ? 'member-academy-course-item--promotion-locked' : '',
                    ]
                      .filter(Boolean)
                      .join(' ')}
                  >
                    <button
                      type="button"
                      className={[
                        'member-academy-course-item__main',
                        isSearchMatch ? 'member-academy-course-item__main--search-match' : '',
                        isPromotionLocked ? 'member-academy-course-item__main--promotion-locked' : '',
                      ]
                        .filter(Boolean)
                        .join(' ')}
                      onClick={() => onSelectCourse(course.id)}

                      data-resource="private.navbar.academy"

                      data-action="read"

                      data-route="/api/user/academy/catalog"

                      data-description="Academy → Course list"

                    >

                      <span className="member-academy-course-item__name">{course.displayName}</span>

                      <span className="member-academy-course-item__meta">

                        {documentCount} document{documentCount === 1 ? '' : 's'}

                      </span>

                    </button>

                  </div>

                );

              })}

            </React.Fragment>

          ))

        )}

      </div>

    </div>

  );

}

